/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Status_Member_SyncInputs */



/**
* | output |
* | --- |
* | "VEKN member sync" |
*
* @param {Admin_Status_Member_SyncInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_status_member_sync = /** @type {((inputs?: Admin_Status_Member_SyncInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Status_Member_SyncInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Synchronisation des membres VEKN")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sincronización de miembros VEKN")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sincronização de membros VEKN")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sincronizzazione membri VEKN")
	return /** @type {LocalizedString} */ ("VEKN member sync")
});